import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c08792a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-radio" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array,
    default: () => []
  },
  activeValue: {
    type: [Number, String],
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:activeValue'],
  setup(__props, { emit }) {

const props = __props
const b2bImg = require('@/assets/image/vipImg/radio-check-b2b.png')
const d2cImg = require('@/assets/image/vipImg/radio-check-d2c.png')

const activeImg = ref()
activeImg.value = isD2C() ? d2cImg : b2bImg

// const activeValue = ref('')
const change = (value: any) => {
  // activeValue.value = value
  if (props.disabled) {
    return
  }
  emit('update:activeValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{ active: item.value === props.activeValue, disabled: __props.disabled && (item.value !== props.activeValue) }, 'radio-item radio-item-guide']),
        key: index,
        onClick: ($event: any) => (change(item.value)),
        style: _normalizeStyle({ width: (item.width || 200) + 'px' })
      }, [
        _createElementVNode("img", {
          src: activeImg.value,
          alt: ""
        }, null, 8, _hoisted_3),
        _createTextVNode(" " + _toDisplayString(item.name), 1)
      ], 14, _hoisted_2))
    }), 128))
  ]))
}
}

})